import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { downloadPDF } from '../../../../utility/event'

import Modal from '../../../common/Modal'
import PairingsReport from './PairingsReport'
import LeaderboardReport from './LeaderboardReport'
import SubmitButton from '../../../common/buttons/SubmitButton'
import Scorecards from './Scorecards'
import Scoreboards from './Scoreboards'
import AlphaReport from './AlphaReport'
import CartSigns from './CartSigns'

import PropTypes from 'prop-types'
import classNames from 'classnames'
import classes from './PreviewModal.module.scss'

const PreviewModal = ({ showModal, closeModal, report, event, printOptions }) => {
  const { t } = useTranslation()
  const [loader, setLoader] = useState(false)

  const downloadReport = (type) => {
    setLoader(true)
    downloadPDF(type, event.name, printOptions).then(() => {
      setLoader(false)
      closeModal()
    })
  }

  return (
    <Modal
      isOpen={showModal}
      onClose={closeModal}
      onRequestClose={closeModal}
      contentLabel={t('events.reports.previewModal.contentLabel')}
      className={classes.previewModal}
      autoFocus
    >
      <div className={classes.modalTitle}>
        {t('events.reports.previewModal.title')}
      </div>
      <div className={classes.modalBody}>
        {report === 'PairingsTeeSheet' && <PairingsReport/>}
        {report === 'PairingsAlphaTeeSheet' && <AlphaReport/>}
        {report === 'ScoreCards' && <Scorecards printOptions={printOptions}/>}
        {report === 'ScoreBoards' && <Scoreboards/>}
        {report === 'Leaderboard' && <LeaderboardReport/>}
        {report === 'CartSigns' && <CartSigns/>}
      </div>

      <div className={classes.modalFooter}>
        <div className={classNames(classes.downloadButton, 'pull-right')}>
          <SubmitButton
            onClick={() => downloadReport(report, printOptions)}
            buttonMessage={loader ? t('events.common.loadingReport') : t('events.common.downloadReport')}
            buttonColor='orange-button'
            disabled={loader}
            loading={loader}
          />
        </div>
      </div>
    </Modal>
  )
}

PreviewModal.propTypes = {
  showModal: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
  report: PropTypes.string,
  event: PropTypes.shape({
    name: PropTypes.string,
  }),
  printOptions: PropTypes.shape({
    oneSided: PropTypes.bool,
    doubleSided: PropTypes.bool,
  }),
}

export default PreviewModal
